import React from 'react';
import { CheckCircleIcon, StarIcon } from 'lucide-react';
export function JealousHero() {
  return <section className="relative w-full pt-32 pb-20 px-4" style={{
    background: 'linear-gradient(135deg, #DCE9F3 0%, #E8F1F8 100%)'
  }} data-id="element-274">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-275">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center" data-id="element-276">
          {/* Left Column */}
          <div className="w-full lg:w-1/2 flex flex-col items-start" data-id="element-277">
            <p className="mb-4" style={{
            color: '#3B8AC4',
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            fontSize: '13px'
          }} data-id="element-278">
              RESIDENTIAL &amp; COMMERCIAL POWER WASHING
            </p>

            <h1 className="mb-6 leading-[1.1]" style={{
            color: '#1F2937',
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontWeight: 800,
            letterSpacing: '-0.02em',
            fontSize: 'clamp(36px, 5vw, 48px)'
          }} data-id="element-279">
              Make Your Neighbors{' '}
              <span style={{
              color: '#3B8AC4'
            }} data-id="element-280">
                Jealous.
              </span>
            </h1>

            <p className="mb-8 max-w-[480px]" style={{
            color: '#4F5B69',
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontWeight: 400,
            fontSize: '18px',
            lineHeight: 1.6
          }} data-id="element-281">
              Get a $500 professional driveway &amp; porch refresh for just $167
              — commercial-grade equipment, guaranteed results, one visit.
            </p>

            <div className="flex items-end gap-4 mb-2" data-id="element-282">
              <span style={{
              color: '#9CA3AF',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 700,
              fontSize: '24px',
              textDecoration: 'line-through',
              marginBottom: '8px'
            }} data-id="element-283">
                $500
              </span>
              <span style={{
              color: '#3B8AC4',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 800,
              fontSize: '52px',
              lineHeight: 1,
              letterSpacing: '-0.02em'
            }} data-id="element-284">
                $167
              </span>
            </div>
            <p className="mb-8" style={{
            color: '#6B7280',
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontWeight: 600,
            fontSize: '13px'
          }} data-id="element-285">
              one-time
            </p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-8" data-id="element-286">
              <a href="#package" className="text-center transition-all hover:-translate-y-1" style={{
              backgroundColor: '#3B8AC4',
              color: '#FFFFFF',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 700,
              fontSize: '16px',
              padding: '16px 32px',
              borderRadius: '8px',
              boxShadow: '0 4px 14px rgba(59,138,196,0.3)'
            }} data-id="element-287">
                Claim Your 67% Discount
              </a>
              <a href="tel:4805998442" className="text-center transition-all hover:-translate-y-1" style={{
              backgroundColor: 'transparent',
              color: '#3B8AC4',
              border: '2px solid #3B8AC4',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 700,
              fontSize: '16px',
              padding: '14px 32px',
              borderRadius: '8px'
            }} data-id="element-288">
                Call Us
              </a>
            </div>

            <div className="flex flex-col gap-2" data-id="element-289">
              <span style={{
              color: '#4F5B69',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 600,
              fontSize: '14px'
            }} data-id="element-290">
                <span style={{
                color: '#2EAE6A'
              }} data-id="element-291">
                  ✓
                </span>{' '}
                Licensed · Bonded · Insured
              </span>
              <div className="flex items-center gap-2" data-id="element-292">
                <div className="flex gap-0.5" data-id="element-293">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#FBB034] text-[#FBB034]" data-id="element-294" />)}
                </div>
                <span style={{
                color: '#4F5B69',
                fontFamily: '"Plus Jakarta Sans", sans-serif',
                fontSize: '13px'
              }} data-id="element-295">
                  from 150+ reviews on Google
                </span>
              </div>
            </div>
          </div>

          {/* Right Column - Package Card */}
          <div id="package" className="w-full lg:w-1/2 relative mt-10 lg:mt-0" data-id="element-296">
            {/* Discount Badge */}
            <div className="absolute -top-4 -right-2 sm:-right-4 z-20 px-4 py-2 rounded-full" style={{
            backgroundColor: '#F27A3A',
            boxShadow: '0 4px 12px rgba(242,122,58,0.3)'
          }} data-id="element-297">
              <span style={{
              color: '#FFFFFF',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 800,
              fontSize: '16px'
            }} data-id="element-298">
                67% OFF
              </span>
            </div>

            <div className="w-full rounded-[16px] p-6 sm:p-8 relative bg-white" style={{
            boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
          }} data-id="element-299">
              <h2 className="mb-5" style={{
              color: '#1F2937',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 800,
              fontSize: '20px'
            }} data-id="element-300">
                The Jealous Neighbor Package
              </h2>

              <div className="w-full h-px bg-gray-100 mb-5" data-id="element-301" />

              <div className="flex flex-col gap-4 mb-5" data-id="element-302">
                {[{
                name: '2-Car Driveway Deep Clean',
                val: '$200'
              }, {
                name: 'Front Porch Wash',
                val: '$100'
              }, {
                name: 'Interior Porch Soft Wash',
                val: '$50'
              }, {
                name: 'Walkway & Sidewalk Wash',
                val: '$75'
              }].map((item, i) => <div key={i} className="flex items-center justify-between" data-id="element-303">
                    <div className="flex items-center gap-3" data-id="element-304">
                      <CheckCircleIcon className="w-5 h-5 text-[#2EAE6A]" data-id="element-305" />
                      <span style={{
                    color: '#1F2937',
                    fontFamily: '"Plus Jakarta Sans", sans-serif',
                    fontSize: '15px',
                    fontWeight: 500
                  }} data-id="element-306">
                        {item.name}
                      </span>
                    </div>
                    <span style={{
                  color: '#9CA3AF',
                  fontFamily: '"Plus Jakarta Sans", sans-serif',
                  fontSize: '15px'
                }} data-id="element-307">
                      {item.val}
                    </span>
                  </div>)}
              </div>

              <div className="flex flex-col gap-4 mb-6" data-id="element-308">
                {[{
                name: 'Garage Door Rinse',
                val: 'FREE'
              }, {
                name: '$75 Future Service Credit',
                val: '$75'
              }].map((item, i) => <div key={i} className="flex items-center justify-between" data-id="element-309">
                    <div className="flex items-center gap-3" data-id="element-310">
                      <CheckCircleIcon className="w-5 h-5 text-[#FBB034]" data-id="element-311" />
                      <div className="flex items-center gap-2 flex-wrap" data-id="element-312">
                        <span className="px-2 py-0.5 rounded-full text-[10px]" style={{
                      backgroundColor: '#FFF8EB',
                      color: '#FBB034',
                      fontFamily: '"Plus Jakarta Sans", sans-serif',
                      fontWeight: 700
                    }} data-id="element-313">
                          BONUS
                        </span>
                        <span style={{
                      color: '#1F2937',
                      fontFamily: '"Plus Jakarta Sans", sans-serif',
                      fontSize: '15px',
                      fontWeight: 500
                    }} data-id="element-314">
                          {item.name}
                        </span>
                      </div>
                    </div>
                    <span style={{
                  color: '#9CA3AF',
                  fontFamily: '"Plus Jakarta Sans", sans-serif',
                  fontSize: '15px'
                }} data-id="element-315">
                      {item.val}
                    </span>
                  </div>)}
              </div>

              <div className="w-full h-[2px] bg-gray-100 mb-6" data-id="element-316" />

              <div className="flex items-center justify-between mb-6" data-id="element-317">
                <span style={{
                color: '#4F5B69',
                fontFamily: '"Plus Jakarta Sans", sans-serif',
                fontWeight: 700,
                fontSize: '16px'
              }} data-id="element-318">
                  Total Value
                </span>
                <div className="flex items-center gap-3" data-id="element-319">
                  <span style={{
                  color: '#9CA3AF',
                  fontFamily: '"Plus Jakarta Sans", sans-serif',
                  fontWeight: 700,
                  fontSize: '18px',
                  textDecoration: 'line-through'
                }} data-id="element-320">
                    $500
                  </span>
                  <span style={{
                  color: '#2EAE6A',
                  fontFamily: '"Plus Jakarta Sans", sans-serif',
                  fontWeight: 800,
                  fontSize: '30px',
                  lineHeight: 1
                }} data-id="element-321">
                    $167
                  </span>
                </div>
              </div>

              <a href="tel:4805998442" className="block w-full text-center transition-all hover:-translate-y-1" style={{
              backgroundColor: '#F27A3A',
              color: '#FFFFFF',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 700,
              fontSize: '18px',
              padding: '16px 20px',
              borderRadius: '8px',
              boxShadow: '0 4px 14px rgba(242,122,58,0.3)'
            }} data-id="element-322">
                Book Now — Save $333
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}